<template>
  <div>
    <el-table  height="226.5px" stripe :header-cell-style="getCellClass" row-key="d_id" ref="multipleTable"
               :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
               @sort-change="sortChange" :data="tableData">
      <el-table-column prop="taskName" label="任务名称" min-width="160" fixed="left" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_text_click_new" @click="showDialogVisible('create', {id:scope.row.taskId,title:scope.row.taskName})">【{{scope.row.taskId}}】{{scope.row.taskName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="taskStatus" label="状态" width="80"  fixed="left" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="task_type" label="任务类型" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span> {{NEWOTHERTYPE[scope.row.task_type]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="creator_id" label="创建人" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.creator_id.nameZh?scope.row.creator_id.nameZh:''}} {{scope.row.creator_id.nameEn?'('+scope.row.creator_id.nameEn+')':''}} </span>
        </template>
      </el-table-column>
      <el-table-column prop="owner_id" label="责任人" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.owner_id.nameZh?scope.row.owner_id.nameZh:''}} {{scope.row.owner_id.nameEn?'('+scope.row.owner_id.nameEn+')':''}} </span>
        </template>
      </el-table-column>
      <el-table-column prop="deployDate" label="计划完成日期" width="120" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <create v-if="dialogVisible.create" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.create'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
  </div>
</template>
<script>
import { create } from '@/views/tops/devOps/producerSpace/components/other'
import {mapState} from "vuex";
import {getDevOpsSpaceOtherListApi} from "@/server/tops/devOps";

export default {
  components: {create},
  props: {
    tableData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 弹出层部分
      dialogVisible: {
        create: false,
      },
      // 选中信息
      checkedInfo: {},
    }
  },
  async mounted() {
  },
  created() {
  },
  computed: {
    ...mapState(
        {
          NEWOTHERTYPE: (state) => state.devOps.NEWOTHERTYPE
        }
    ),
  },
  methods:{
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;font-size:12px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 弹出模板
    async showDialogVisible(type, row) {
      if (type === 'releaseing') {
        return;
      }
      //await this.hideDialogVisible('', false)
      this.checkedInfo = row;
      this.dialogVisible[type] = true;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      if (nextStep && (typeof(nextStep) === 'string')) {
        //const params = nextStep === 'demand' ? { title: this.checkedInfo?.id} : {}
        /*const params = { title: this.checkedInfo?.id};
        const ret = await getDevOpsSpaceOtherListApi(params);
        const tableData = ret.data || [];
        this.checkedInfo = tableData[0];*/
        this.$nextTick(() => {
          this.dialogVisible[nextStep] = true;
        })
      } else {
        //search && await this.formSearch()
      }
      this.$emit('changeTask');
    },
  },
}
</script>
